import { Text } from '@thanx/uikit/text'
import { Role } from 'api/roles'
import { RoleBadge } from 'components/RoleBadge'
import Section from 'components/Section'
import { BadgeVariant, getRoleBadgeVariant } from 'constants/roles'
import { buildTranslate } from 'locales'
import { useRef, useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Dropdown } from 'react-bootstrap-five'
import { Link } from 'react-router-dom'
import { generateId } from 'utilities/uniqueId'

type Props = {
  role: Role
  badgeVariant?: BadgeVariant
  canManage?: boolean
  onDelete: (role: Role) => void
}

const t = buildTranslate('dashboard_access.roles_tab')

export const RoleCard = ({
  role,
  badgeVariant,
  canManage = false,
  onDelete,
}: Props) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const tooltipId = useRef(`card-tooltip-${generateId()}`).current
  const isPreset = role.preset
  const canDelete = canManage && !isPreset
  const showMenu = !isPreset
  const count = role.users_count

  return (
    <Section className="p-l">
      <div className="d-flex justify-content-between align-items-start">
        <Text.Header4 className="m-0">{role.display_name}</Text.Header4>
        <div className="d-flex align-items-center">
          {showMenu && (
            <Dropdown show={menuOpen} onToggle={open => setMenuOpen(open)}>
              <Dropdown.Toggle
                bsPrefix="none"
                className="border-0 bg-transparent p-0 mr-xs cursor-pointer grey-70"
                aria-label={t('actions_for', { roleName: role.display_name })}
              >
                <i className="fa fa-ellipsis-h" aria-hidden="true" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {canDelete ? (
                  <Dropdown.Item onClick={() => onDelete(role)}>
                    {t('delete')}
                  </Dropdown.Item>
                ) : (
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id={tooltipId}>{t('requires_admin')}</Tooltip>
                    }
                  >
                    <span>
                      <Dropdown.Item disabled aria-label={t('requires_admin')}>
                        {t('delete')}
                      </Dropdown.Item>
                    </span>
                  </OverlayTrigger>
                )}
              </Dropdown.Menu>
            </Dropdown>
          )}
          <Link
            to={`/merchant_users/roles/${role.id}`}
            className="spearmint-70"
          >
            {canManage && !isPreset ? t('edit') : t('view')}
          </Link>
        </div>
      </div>
      <div className="d-flex align-items-center mt-s">
        <RoleBadge
          variant={badgeVariant ?? getRoleBadgeVariant(role)}
          className="mr-xs"
        />
        {count !== undefined && (
          <Text.BodyText4 color="grey70">
            {count === 1
              ? t('user_count', { count })
              : t('user_count_plural', { count })}
          </Text.BodyText4>
        )}
      </div>
    </Section>
  )
}
